import { render, staticRenderFns } from "./CvFiscal.vue?vue&type=template&id=5d0476c4&scoped=true"
import script from "./CvFiscal.vue?vue&type=script&lang=js"
export * from "./CvFiscal.vue?vue&type=script&lang=js"
import style0 from "./CvFiscal.vue?vue&type=style&index=0&id=5d0476c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0476c4",
  null
  
)

export default component.exports